import { DrawingClubWCGroupBasketsDto } from "./drawing-club-wc-group-baskets.dto";

export class DrawingCWCGroupStageRequest
{
    baskets: DrawingClubWCGroupBasketsDto;
    mds: number[];
}